
function load(data) {
	return {
		url: `/morty/assistant/queue`,
		method: 'GET'
	};
}


function loadLive(data) {
	return {
		url: `/morty/assistant/queue/live?cursor=${data}`,
		method: 'GET'
	};
}


function loadMentor(data) {
	return {
		url: `/morty/assistant/queue/mentor?cursor=${data}`,
		method: 'GET'
	};
}

function loadUnclaimed(data) {
	return {
		url: `/morty/assistant/queue/unclaimed?cursor=${data}`,
		method: 'GET'
	};
}

function loadClaimed(data) {
	return {
		url: `/morty/assistant/queue/claimed?cursor=${data}`,
		method: 'GET'
	};
}


function loadCalls(data) {
	return {
		url: `/morty/assistant/queue/calls?cursor=${data}`,
		method: 'GET'
	};
}


/* dismiss a queue entity */
function dismiss(data) {
	return {
		url: `/morty/assistant/queue/dismiss`,
		method: 'POST',
		body: { request_key: `${data.requestKey}` }
	};	
}

export { load, loadLive, loadMentor, loadUnclaimed, loadClaimed, loadCalls, dismiss };
